import React, { useState, useEffect } from 'react';
import { Select, Spin } from 'antd';
import axios from 'axios';
import { BACKEND_URL } from '../Backend';

const { Option } = Select;

const SelectCuatrimestre = ({ 
  onCuatrimestreChange, 
  value, 
  placeholder = "Selecciona un cuatrimestre",
  style = { width: '100%' },
  disabled = false 
}) => {
  const [cuatrimestres, setCuatrimestres] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    cargarCuatrimestres();
  }, []);

  const cargarCuatrimestres = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${BACKEND_URL}/cuatrimestres`);
      setCuatrimestres(response.data);
    } catch (error) {
      console.error('Error al cargar cuatrimestres:', error);
      // Opcional: mostrar mensaje de error al usuario
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (value) => {
    if (onCuatrimestreChange) {
      onCuatrimestreChange(value);
    }
  };

  return (
    <Select
      value={value}
      placeholder={placeholder}
      style={style}
      onChange={handleChange}
      disabled={disabled}
      loading={loading}
      showSearch
      optionFilterProp="children"
      filterOption={(input, option) =>
        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
      }
    >
        <Option key="todos" value="">
        Todos los cuatrimestres
      </Option>
      {cuatrimestres.map((cuatrimestre) => (
        <Option key={cuatrimestre.cuatrimestre} value={cuatrimestre.cuatrimestre}>
          {cuatrimestre.cuatrimestre}° Cuatrimestre
        </Option>
      ))}
    </Select>
  );
};

export default SelectCuatrimestre;